/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Create Payment Return Type
 */
export type CreatePaymentRequestCheckoutType = typeof CreatePaymentRequestCheckoutType[keyof typeof CreatePaymentRequestCheckoutType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePaymentRequestCheckoutType = {
  link: 'link',
  element: 'element',
} as const;
